import clsx from 'clsx';

import { ButtonProps, MantineSize, MantineTheme, rem } from '@mantine/core';

import { ExtendedCustomColors } from '../../theme/colors';
import commonStyleClasses from '../styles/Common.module.css';

import buttonClasses from './Button.module.css';

interface ButtonSizeProps {
  height: number;
  paddingX?: number;
  fontSize: number;
  bgColor?: ExtendedCustomColors;
}

export const DefaultButtonProps: Partial<ButtonProps> = {
  size: 'xl',
  color: 'primary',
  variant: 'filled',
  radius: 'xs'
};

export const ButtonOverrideClassNames = (
  theme: MantineTheme,
  props: ButtonProps
) => {
  return {
    root: clsx(buttonClasses.root, {
      [buttonClasses.xs]: props.size === 'xs',
      [buttonClasses.sm]: props.size === 'sm',
      [buttonClasses.md]: props.size === 'md',
      [buttonClasses.lg]: props.size === 'lg',
      [buttonClasses.xl]: props.size === 'xl',
      [commonStyleClasses.primaryButton]: props.color === 'primary',
      [commonStyleClasses.secondaryButton]: props.color === 'secondary',
      [commonStyleClasses.successButton]: props.color === 'success',
      [commonStyleClasses.dangerButton]:
        props.color === 'pink' || props.color === 'red' || props.color === 'danger'
    }),
    section: buttonClasses.sectionButtonStyles,
    loader: buttonClasses.loaderStyles
  };
};

// we should stick with one of the approaches, either write classes using classNames, or use the vars and styles and write all relevant styles here.
// using var resolvers for some properties is recommended, as mantine tries to determine sizes based on theses vars. But we are limited by the number of the vars we can use.
export const sizes: Partial<Record<MantineSize, ButtonSizeProps>> = {
  xs: {
    height: 20,
    fontSize: 10,
    paddingX: 8
  },
  sm: {
    height: 24,
    fontSize: 11,
    paddingX: 8
  },
  md: {
    height: 28,
    fontSize: 12,
    paddingX: 10
  },
  lg: {
    height: 32,
    fontSize: 13,
    paddingX: 12
  },
  xl: {
    height: 40,
    fontSize: 14,
    paddingX: 20
  }
};

export const ButtonVarsResolver = (theme: MantineTheme, props: ButtonProps) => {
  if (props.size === 'xs') {
    return {
      root: {
        '--button-height': rem(sizes?.xs?.height),
        '--button-fz': rem(sizes?.xs?.fontSize),
        '--button-padding-x': rem(sizes?.xs?.paddingX)
      }
    };
  } else if (props.size === 'sm') {
    return {
      root: {
        '--button-height': rem(sizes?.sm?.height),
        '--button-fz': rem(sizes?.sm?.fontSize),
        '--button-padding-x': rem(sizes?.sm?.paddingX)
      }
    };
  } else if (props.size === 'md') {
    return {
      root: {
        '--button-height': rem(sizes?.md?.height),
        '--button-fz': rem(sizes?.md?.fontSize),
        '--button-padding-x': rem(sizes?.md?.paddingX)
      }
    };
  } else if (props.size === 'lg') {
    return {
      root: {
        '--button-height': rem(sizes?.lg?.height),
        '--button-fz': rem(sizes?.lg?.fontSize),
        '--button-padding-x': rem(sizes?.lg?.paddingX)
      }
    };
  } else if (props.size === 'xl') {
    return {
      root: {
        '--button-height': rem(sizes?.xl?.height),
        '--button-fz': rem(sizes?.xl?.fontSize),
        '--button-padding-x': rem(sizes?.xl?.paddingX)
      }
    };
  } else {
    return {
      root: {
        '--button-height': rem(sizes?.md?.height),
        '--button-fz': rem(sizes?.md?.fontSize),
        '--button-padding-x': rem(sizes?.md?.paddingX)
      }
    };
  }
};
